import dateFormat from 'dateformat';

/**
 * Takes a dateString / number and returns a nicely formatted string
 * @param dateString
 * @return {*}
 */
export function formatDateStringToNiceHumanDate(dateString){
	try {
		return dateFormat(new Date(dateString), "dd-mmm-yyyy HH:MM:ss");
	} catch(e){
		return `${e.message} ${dateString}`;
	}
}

/**
 * Takes in amount of seconds, return a nicely formatted string
 * @param floatSecondVal
 * @return {string}
 */
export function formatNumberIntoNiceEntireString(floatSecondVal){
	if ( !isNaN(floatSecondVal) && floatSecondVal !== null ) {
		let niceString = '',
			roundedNumber = floatSecondVal.toFixed(0);
		if (roundedNumber.length < 2)
			niceString += '0';

		niceString += roundedNumber;
		return niceString;
	} else {
		return '--';
	}
}

/**
 *
 * @param totalSeconds
 */
export function formatSecondsToMinuteSecons(totalSeconds) {
	let minutes = Math.floor(totalSeconds / 60),
		seconds = totalSeconds - minutes * 60;


	return formatNumberIntoNiceEntireString(minutes)+':'+formatNumberIntoNiceEntireString(seconds)

}

export function cloneDeep(obj) {
	return JSON.parse(JSON.stringify(obj));
}